module.exports = __webpack_public_path__ + "10f3f79fb19ac63b8bd52f1e0f21561d.jpg";